import React, { useState } from "react";
import { Clock, X, Phone } from "lucide-react";

const PHONE = "07876664591";

export default function ClosedBanner({ store }) {
  const [dismissed, setDismissed] = useState(false);

  if (!store || store.is_open || store.preview_mode || dismissed) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-0 pointer-events-none">
      <div
        className="w-full pointer-events-auto bg-black border-b-4 border-accent shadow-[0_8px_40px_0_rgba(0,0,0,0.8)] animate-fade-up"
        data-testid="closed-banner"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center gap-4 justify-between">
          <div className="flex items-start gap-4">
            <div className="shrink-0 w-10 h-10 flex items-center justify-center border-2 border-accent mt-0.5">
              <Clock className="h-5 w-5 text-accent" />
            </div>
            <div>
              <div className="font-heading uppercase tracking-widest text-accent text-lg leading-tight">
                We're Currently Closed
              </div>
              <p className="text-cream/80 text-sm mt-1">
                We're open <span className="text-gold font-semibold">{store.hours_label}</span> on{" "}
                <span className="text-gold font-semibold">{store.open_days?.join(", ")}</span>.
              </p>
              {store.next_open_label && (
                <p className="text-cream/60 text-sm mt-0.5">
                  Next opening: <span className="text-cream font-semibold">{store.next_open_label}</span>
                </p>
              )}
            </div>
          </div>

          <div className="flex items-center gap-3 shrink-0">
            <a
              href={`tel:${PHONE}`}
              className="inline-flex items-center gap-2 px-4 py-2 border-2 border-gold text-gold font-heading uppercase tracking-wider text-sm hover:bg-gold hover:text-black transition-colors"
            >
              <Phone className="h-4 w-4" /> {PHONE}
            </a>
            <button
              onClick={() => setDismissed(true)}
              className="p-2 border border-border text-cream/50 hover:text-cream hover:border-cream transition-colors"
              aria-label="Dismiss"
              data-testid="closed-banner-dismiss"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
